import { render } from "./elem.vue?vue&type=template&id=b36d28f0"
import script from "./elem.vue?vue&type=script&lang=js"
export * from "./elem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__